<template>

    <div id="app" class="d-flex flex-column">
        <div class="page-content">
            <Header></Header>
            <div class="page-content mt-3 mb-3">
                <router-view/>
            </div>
        </div>
        <Footer class="sticky-footer"></Footer>
    </div>

</template>

<script>
  import Vue from 'vue'
  import Header from './components/Header'
  import Footer from './components/Footer'

  export default {
    name: 'App',

    components: {
      Header,
      Footer
    },

    data () {
      return {}
    }
  }
</script>





// WEBPACK FOOTER //
// src/App.vue